import LocationMap from "./LocationMap.jsx";

export default LocationMap;
